import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import IconButton from "components/common/IconButton";
import Select from "components/common/Select";
import { ICON_NAMES } from "./Pagination";
const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings.xs};
    margin-top: 10px;
    overflow: hidden;
    padding: 2px;
  `
);
const PageSelectWrapper = styled.div`
  min-width: 80px;
`;
const StyledIconButton = styled(IconButton)`
  border: 1px solid ${({ theme }) => theme.colors.input.border};
  height: 29px;
  width: 29px;
`;
const CompactPagination = ({ currentPage, totalPages, disabled = false, onChange = () => {
} }) => {
  const { t } = useTranslation("common");
  const pageOptions = useMemo(
    () => Array.from({ length: totalPages }, (_, index) => ({ label: String(index + 1), value: index + 1 })),
    [totalPages]
  );
  if (totalPages <= 1 || currentPage > totalPages) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Container, { "data-testid": "graylog-compact-pagination" }, /* @__PURE__ */ React.createElement(
    StyledIconButton,
    {
      name: ICON_NAMES.PREVIOUS,
      title: t("compact_pagination.previous_page"),
      disabled: disabled || currentPage <= 1,
      onClick: () => onChange(currentPage - 1)
    }
  ), /* @__PURE__ */ React.createElement(PageSelectWrapper, null, /* @__PURE__ */ React.createElement(
    Select,
    {
      "aria-label": t("compact_pagination.select_page"),
      options: pageOptions,
      value: currentPage,
      onChange: (page) => onChange(Number(page)),
      clearable: false,
      disabled,
      size: "small"
    }
  )), t("compact_pagination.of_pages", { totalPages }), /* @__PURE__ */ React.createElement(
    StyledIconButton,
    {
      name: ICON_NAMES.NEXT,
      onClick: () => onChange(currentPage + 1),
      title: t("compact_pagination.next_page"),
      disabled: disabled || currentPage >= totalPages
    }
  ));
};
export default CompactPagination;
